module.exports = __webpack_public_path__ + "static/media/download-icon.afac4156.svg";